import { createAction, props } from "@ngrx/store";

export const log = createAction("[Loki] Log", props<{ args: unknown[] }>());
